export function Refresh({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.8333 7.00033C12.8333 10.2203 10.22 12.8337 6.99999 12.8337C3.77999 12.8337 1.81416 9.59033 1.81416 9.59033M1.81416 12.507V9.59033H4.45082M1.16666 7.00033C1.16666 3.78033 3.75666 1.16699 6.99999 1.16699C10.8908 1.16699 12.8333 4.41033 12.8333 4.41033M10.2433 4.41033H12.8333V1.49366"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
